import { fromJS } from 'immutable';
import { DocumentTypesEnum } from '../document-data/document-data.data';
import { Document } from '../document-data/document.model';

export class PurchaseOrder extends Document {
  static ENTITY_TYPE: DocumentTypesEnum = DocumentTypesEnum.purchase_order;
  static KEYS: any = Document.KEYS;
  static CONTENT_KEYS: any = Document.CONTENT_KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get ENTITY_TYPE(): string {
    return PurchaseOrder.ENTITY_TYPE;
  }
}
